import React from 'react';
import { Shield, Clock, FileText } from 'lucide-react';
import { features } from '../../data/mock';

const iconMap = {
  Shield: Shield,
  Clock: Clock,
  FileText: FileText
};

export const Features = () => {
  return (
    <section id="features" className="bg-black py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-white leading-tight tracking-tight mb-4">
            Secure Documentation,
            <span className="text-[#C9A962]"> Simplified</span>
          </h2>
          <p className="text-white/60 text-lg leading-relaxed">
            Everything you need to document, organize, and report on incidents with confidence.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group p-8 bg-white/[0.02] border border-white/10 transition-all duration-400 hover:border-[#C9A962]/30 hover:bg-white/[0.04]"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#C9A962]/10 mb-6">
                  <IconComponent size={24} className="text-[#C9A962]" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-white/60 text-base leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
